/**
 * Visually hidden until focused — the canonical "skip to main content" link.
 * Place at the very top of the layout so screen-reader / keyboard users can
 * bypass repetitive nav.
 */
export default function SkipToContent({ targetId = "main-content" }) {
  return (
    <a
      href={`#${targetId}`}
      data-testid="skip-to-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#0A140F] focus:text-[#F8F7F4] focus:font-mono focus:text-[12px] focus:tracking-[0.2em] focus:uppercase focus:outline focus:outline-2 focus:outline-[#0E8B7E]"
    >
      Skip to content
    </a>
  );
}
